import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { DsBoxModule, DsProgressCircleModule } from '@bmw-ds/components';

import { useI18n } from '../i18n/services/i18n.service';
import { LoadingIndicatorComponent } from '../loading/loading-indicator.component';
import { VersionService } from './services/version.service';

@Component({
  selector: 'cdf-version',
  imports: [LoadingIndicatorComponent, DsProgressCircleModule, DsBoxModule],
  template: `
    <div class="break-anywhere">
      @if (versionResource.isLoading() || versionResource.value() === undefined) {
        <div class="flex-wrapper">
          <span>{{ i18n('version.label') }}</span>
          @if (versionResource.isLoading()) {
            <cdf-loading-indicator noSpacing />
          } @else {
            <i>n/a</i>
          }
        </div>
      } @else {
        <span class="version">{{ versionResource.value() }}</span>
      }
    </div>
  `,
  styleUrl: 'version.component.scss',
})
export class VersionComponent {
  protected readonly versionService = inject(VersionService);
  protected readonly i18n = useI18n();

  protected readonly versionResource = rxResource({
    stream: () => this.versionService.getVersion(),
    defaultValue: undefined,
  });
}
